export default __webpack_public_path__ + "static/media/ant.93fb44aa.jpeg";